import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="splash">
      <div className="splash-content">
        <div className="splash-logo">◆</div>
        <div className="splash-text">Loading</div>
        <div className="splash-bar"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
